// src/data/dataProvider.js
import simpleRestProvider from 'ra-data-simple-rest';
import { adminApiUrl, httpClient } from '../config/api';

// NB: le backend doit renvoyer Content-Range + Access-Control-Expose-Headers pour GET_LIST
export default simpleRestProvider(adminApiUrl, httpClient);
